import { Module, Mutation, VuexModule, Action } from "vuex-module-decorators";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import {
  orderPay,
  getCustomOrderDetail,
  payResult,
  queryActivityGiveaway,
  paymentDiscountList,
  checkOutCartWt,
  orderPayWt
} from "@/graphql/order.gql";
import { getMyBonusAccount } from "@/graphql/account.gql";
import { GTGroupFixedParam } from "@/enums/app";

const defaultPriceMap = () => ({
  payPrice: 0,
  originPrice: 0,
  promotionPrice: 0
});

const getPaymentTimeControlMap = () => {
  try {
    return JSON.parse(localStorage.getItem("paymentTimeControlMap") || "{}");
  } catch (e) {
    return {};
  }
};
export interface PaymentState {
  order: any;
  paymentTimeControlMap: any;
}

@Module({ name: "PaymentModule", namespaced: true })
export default class PaymentModule
  extends VuexModule<PaymentState, RootState>
  implements PaymentState {
  // 订单信息
  public order: any = {};
  // 奖励金余额
  public bountyBalance: number = 0;

  // 金额集合
  public priceMap = defaultPriceMap();
  // 支付时间控制，比如，5分钟之内，一个订单，一种支付方式只能支付方式。
  // key：订单号，value：支付方式-时间戳
  public paymentTimeControlMap: any = getPaymentTimeControlMap();

  @Mutation
  saveTimeControlMapMutation({ key, value }: any = {}) {
    if (key) {
      this.paymentTimeControlMap = Object.assign(
        {},
        getPaymentTimeControlMap(),
        {
          [key]: value
        }
      );
    } else {
      this.paymentTimeControlMap = {};
    }
    // app出现vuex存储失败，使用本地存储
    localStorage.setItem(
      "paymentTimeControlMap",
      JSON.stringify(this.paymentTimeControlMap)
    );
  }

  @Mutation
  savePriceMapMutation(data: any = defaultPriceMap()) {
    this.priceMap = data || defaultPriceMap();
  }

  @Mutation
  saveOrderMutation(data: any) {
    this.order = data ?? {};
  }

  @Mutation
  saveBountyBalanceMutation(data: number) {
    this.bountyBalance = +data || 0;
  }

  @Action
  async getCustomOrderDetailAction(variables) {
    const data = await queryRequest({
      query: getCustomOrderDetail,
      variables
    });
    this.context.commit("saveOrderMutation", data);
  }

  @Action
  async getBountyAction() {
    const { accountOuterSubsetList = [] } = await queryRequest({
      query: getMyBonusAccount
    });
    this.context.commit(
      "saveBountyBalanceMutation",
      (accountOuterSubsetList.find(o => o.fundType === "02") || {})
        .accountAmount
    );
  }

  @Action
  async orderPayAction(variables: any) {
    return await queryRequest({
      query: orderPay,
      variables
    });
  }

  @Action
  async payResultAction(variables: any) {
    return await queryRequest({
      query: payResult,
      variables
    });
  }

  @Action
  async queryActivityGiveawayAction(variables) {
    return await queryRequest({
      query: queryActivityGiveaway,
      variables
    });
  }

  @Action
  async paymentDiscountListAction(variables) {
    return await queryRequest({
      query: paymentDiscountList,
      variables
    });
  }

  @Action
  async paymentCheckoutAction(variables) {
    return await queryRequest({
      query: checkOutCartWt,
      variables
    });
  }

  // 创单之后，继续支付使用的，查询支付优惠、支付优惠结算
  @Action
  async orderPayWtAction(variables) {
    return await queryRequest({
      query: orderPayWt,
      variables
    });
  }
}
